/* ============================================================
   MISSKOSIKAS · CAPA DE DETALLE
   Lo mínimo que no se puede hacer solo con CSS.

   Sin un solo listener de scroll, ni en móvil ni en escritorio:
   se usa un centinela invisible arriba del todo y un
   IntersectionObserver, que el navegador resuelve fuera del hilo
   principal. Es la diferencia entre un header que se compacta
   suave y uno que da tirones al hacer scroll en un teléfono.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- header compacto al bajar ---------- */
  var centinela = document.createElement('div');
  centinela.setAttribute('aria-hidden', 'true');
  centinela.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80px;pointer-events:none';
  document.body.prepend(centinela);

  new IntersectionObserver(function (entradas) {
    document.body.classList.toggle('mk-scrolled', !entradas[0].isIntersecting);
  }, { threshold: 0 }).observe(centinela);

  /* ---------- el nombre del color elegido, en vivo ----------
     El <legend> de la ficha muestra el valor seleccionado, pero
     Shopify solo lo actualiza al recargar la variante. Esto lo
     refresca en cuanto se toca una muestra. */
  document.querySelectorAll('.mk-variantes').forEach(function (grupo) {
    var salida = grupo.querySelector('.mk-variantes__sel');
    if (!salida) return;
    grupo.addEventListener('change', function (e) {
      if (e.target.type === 'radio') salida.textContent = e.target.value;
    });
  });

  /* ---------- barra de anuncio: fundido en vez de corte ----- */
  var barra = document.querySelector('.header-announcements, .announcement-bar');
  if (barra) barra.style.setProperty('transition', 'opacity 300ms ease');
})();

/* ============================================================
   LA FOTO SIGUE A LA VARIANTE
   Si eliges la funda verde, la que se ve en grande es la verde.
   Antes la galería se quedaba siempre en la primera foto y había
   que buscar a mano cuál era la que estabas comprando.

   La galería es un carrusel con ajuste de desplazamiento, así que
   "cambiar la foto" es llevar la suya al centro. Cada opción del
   selector lleva el ID de su media y cada foto lleva ese mismo ID.
   ============================================================ */
(function () {
  var galeria = document.querySelector('.mk-gal__principal');
  if (!galeria) return;

  var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mostrar(idMedia, animar) {
    if (!idMedia) return;
    var foto = document.getElementById('mk-media-' + idMedia);
    if (!foto) return;
    /* scrollIntoView movería también la página; aquí sólo debe moverse
       el carrusel, así que se calcula el desplazamiento dentro de él. */
    var destino = foto.offsetLeft - galeria.offsetLeft;
    galeria.scrollTo({ left: destino, behavior: animar && suave ? 'smooth' : 'auto' });

    var minis = document.querySelectorAll('[data-mk-mini]');
    for (var i = 0; i < minis.length; i++) {
      minis[i].classList.toggle('is-actual', minis[i].dataset.mkMini === String(idMedia));
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.dataset.mkMedia) return;
    mostrar(input.dataset.mkMedia, true);
  });

  /* Al entrar con ?variant=… en la dirección, empezar por su foto. */
  var marcado = document.querySelector('.mk-variantes input[type="radio"]:checked');
  if (marcado && marcado.dataset.mkMedia) mostrar(marcado.dataset.mkMedia, false);
})();

/* ============================================================
   AL ELEGIR COLOR, LA FICHA SE PONE AL DÍA
   Sin recarga de página, la ruta de añadir al carrito no entiende
   "options[Color]": necesita el id exacto de la variante. Así que
   al marcar un color se reescribe el campo oculto del formulario.
   Si esto falla, la tienda añade siempre la primera variante y el
   cliente recibe un color que no pidió; por eso va junto al cambio
   de formulario y no después.

   De paso se actualizan el precio, el nombre del color elegido y la
   dirección de la página, para que al compartirla llegue con esa
   variante ya seleccionada.
   ============================================================ */
(function () {
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.type !== 'radio' || !r.dataset.mkVariante) return;

    var form = r.closest('form');
    if (form) {
      var oculto = form.querySelector('input[name="id"]');
      if (oculto) oculto.value = r.dataset.mkVariante;

      var boton = form.querySelector('button[name="add"]');
      if (boton) {
        var agotada = r.dataset.mkDisponible === 'false';
        boton.disabled = agotada;
        boton.textContent = agotada ? 'Agotada' : 'Añadir a la cesta';
      }
    }

    var precio = document.querySelector('.mk-pdp__precio');
    if (precio && r.dataset.mkPrecio) precio.textContent = r.dataset.mkPrecio;

    var etiqueta = document.querySelector('.mk-variantes__sel');
    if (etiqueta) etiqueta.textContent = r.value;

    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', r.dataset.mkVariante);
      window.history.replaceState({}, '', u);
    } catch (err) { /* sin dirección editable, no pasa nada */ }
  });
})();

/* ============================================================
   RED DE SEGURIDAD DEL BOTÓN «ELEGIR»
   La ventana de elección del tema se abre con una transición de
   vista. Si el navegador la aborta —pasa cuando la pestaña no está
   compuesta, y podría pasar en navegadores que la implementen a
   medias— el botón se queda sin hacer nada, que en una tienda es
   peor que no tener ventana.

   Así que si pasado un momento la ventana no está abierta, se va a
   la ficha del producto, que es el comportamiento de siempre. Con
   ventana se gana comodidad; sin ella, no se pierde la venta.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('.quick-add__button--choose');
    if (!boton) return;

    var tarjeta = boton.closest('.mk-card');
    var enlace = tarjeta && tarjeta.querySelector('a[href*="/products/"]');
    if (!enlace) return;

    window.setTimeout(function () {
      var ventana = document.querySelector('quick-add-dialog dialog');
      if (!ventana || !ventana.open) {
        window.location.href = enlace.getAttribute('href');
      }
    }, 900);
  });
})();
